// extracted by mini-css-extract-plugin
export default {"container":"ContactUs_container__P9b7Y","textInfo":"ContactUs_textInfo__K4fUA"};